import MarkdownIt from 'markdown-it';
import DOMPurify from 'dompurify';

const md = new MarkdownIt({
  html: false,     // never pass raw HTML through — first defense layer
  linkify: true,
  breaks: true,
});

/**
 * Render a markdown string to sanitized HTML. Safe to pass to v-html.
 *
 * Duas camadas — mas elas NÃO carregam o mesmo peso, e vale saber qual:
 *
 *   1. markdown-it com `html:false` + o validador de link dele. É QUEM FAZ O
 *      TRABALHO. Medidos ~15 vetores em 2026-09-03 (javascript:/vbscript:/data:
 *      em link e imagem, maiúsculas alternadas, URL-encoding, tab no meio do
 *      esquema, quebra de atributo por aspas, autolink do linkify, comentário
 *      HTML): esta camada barrou todos.
 *
 *   2. DOMPurify. Nos mesmos ~15 vetores ele não mudou o veredito de nenhum —
 *      nos 4 casos em que a saída mudou, apenas DESESCAPOU entidades em
 *      conteúdo de texto (`&quot;` -> `"`), o que não é proteção.
 *
 * A camada 2 fica: ela é o que segura o dia em que alguém virar `html: true`
 * aqui, e é barata. Mas não a trate como a defesa principal — se o `html:false`
 * sair, o buraco é imediato, e nenhum teste deste arquivo pega isso hoje.
 *
 * O nome tem `Sanitizado` porque a regra de QA `no-unsanitized-v-html` exige
 * que o sanitizador esteja visível na expressão do `v-html`.
 */
export function renderMarkdownSanitizado(content: string | null | undefined): string {
  if (!content) {
    return '';
  }
  const raw = md.render(content);
  return DOMPurify.sanitize(raw, { USE_PROFILES: { html: true } });
}
